import React from "react";
import ReactDOM from "react-dom/client";
import MainRouter from "./router";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./shared/styles/global.scss";
import reportWebVitals from "./reportWebVitals";
import "react-toastify/dist/ReactToastify.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <MainRouter />
    </BrowserRouter>
  </HelmetProvider>,
);

reportWebVitals();
